<template>
    <div :class='$route.name === "personal" ? "lg-video-contain lg-collect-video":"lg-video-contain"'>
      <div class="video-items" v-for="(item,index) in formData" :key="index" @click="handleOpenDetail(item)" @mouseleave="is_hover = false" @mouseover="handlePinkCode(item)">
	      <div class="video-level">{{item.user_level}}</div>
          <img :src="item.thumb ? item.thumb:item.course_thumb" alt="" class="video-thumb">
	      <div style="display: flex;flex-flow: column;justify-content: space-between">
		      <p class="video-item-title lg-list-title">{{item.name ? item.name : item.course_name}}</p>
		      <p class="video-item-category"><span class="lg-list-item lg-text-ell">{{$route.name === 'personal'&& $route.query.name==='study' ? item.course_tag:item.tag}}</span> <span v-if="item.user_count !==0" class="lg-list-item space" style="font-size: 14px;font-weight: bold">·</span> <span v-if="item.user_count !==0" class="lg-list-item">观看 {{item.user_count}}人</span></p>
		      <div class="video-item-tag">
			      <p style="display:flex; align-items: center;justify-content: space-between;width: 100%">
				      <span :class="$route.name === 'personal' && $route.query.name === 'collect' ? 'collect-category_tag':'category-tag'" :style="{backgroundColor:item.bg_color}">{{item.category ? item.category : item.course_category}}</span>
				      <span v-if="$route.name !== 'personal'" class="lg-list-item">{{item.created_at}}</span>
			      </p>
			      <p
					  @click.stop="handleCloseCollect(item,index)"
					  v-if="$route.name === 'personal'&&$route.query.name==='collect'" class="collect">
				      <img src="../../assets/img/icon-collect_active.png" alt=""><span class="lg-list-item">已收藏</span>
			      </p>
		      </div>
	      </div>
          <img src="../../assets/img/index/play.png" alt="" class="mask-layer">
	      <img src="../../assets/img/video/pink.png" v-if="item.pink_qrcode !== null && $route.name !== 'personal'" class="pink" alt="">
	      <div :class="is_hover && hover_id === item.id ? 'pink-code pink-code-out' :'pink-code'">
		      <img :src="item.pink_qrcode" alt="">
		      <p>微信扫我拼团</p>
	      </div>
      </div>

    </div>
</template>

<script>
export default {
    props:['formData'],
    data () {
        return {
          is_hover:false,
          hover_id:""
        }
    },
  methods:{
      // 打开拼团二维码
    handlePinkCode(data){
      this.hover_id = data.id
      this.is_hover = data.pink_qrcode !== null && this.$route.name !== "personal"
    },
      // 关闭收藏
      handleCloseCollect(data,index){
        const status = this.$utils.loginStatus()
        if (status) {
          this.$requestApi.index.getUserCollect({
            type:"course",
            source_id:data.id
          }).then(res => this.$Bus.$emit('closeCollect',index))
        }
      },
    // 打开详情
    handleOpenDetail(data){
      const {href} = this.$router.resolve({
        name: 'video_detail',
        query: {
          id:data.id ? data.id : data.course_id
        }
      })
      window.open(href, '_blank')
    }
  }
}
</script>
<style lang="less" scoped>
    .lg-video-contain{
        display: flex;
        flex-flow: wrap;
        margin-right: -20px;
        .video-items{
            width: 265px;
            padding-bottom: 8px;
            border-radius: 6px;
            margin-right: 28px;
            margin-bottom: 20px;
            position: relative;
            cursor: pointer;
            transition: all .3s;
            background-color: #ffffff;
	        display: flex;
	        flex-flow: column;
			justify-content: space-between;
	        /*box-shadow: 0 6px 10px 0 rgba(95,101,105,.15);*/
	        /*拼团标识*/
	        .pink{
		        width: 34px;
		        height: 37px;
		        position: absolute;
		        left: 0;
		        top: 0;
	        }
	        /*拼团码*/
	        .pink-code{
		        width: 265px;
		        background-color: rgba(0, 0, 0, 0.8);
		        height: 0;
		        position: absolute;
		        border-radius: 6px;
		        display: flex;
		        align-items: center;
		        justify-content: center;
		        flex-flow: column;
		        visibility: hidden;
		        transition: all 0.2s linear;
		        img{
			        width: 180px;
			        height: 0;
		        }
		        p{
			        color: #ffffff;
			        margin-top: 10px;
			        font-size: 14px;
			        display: none;
		        }
	        }
	        .pink-code-out{
		        cursor: pointer;
		        visibility:visible;
		        height: 100%;
		        img{
			        height: 180px;
		        }
		        p{
			        display: block;
		        }
	        }
	        .video-level{
		        padding:2px 10px;
		        background: linear-gradient(0deg, #F2CA5B 0%, #FFE6A3 100%);
		        border-radius: 0 3px 0 4px;
		        position: absolute;
		        right: 0;
		        top: 0;
		        font-size: 12px;
		        color: #663D00;
		        font-weight: bold;
	        }
            .mask-layer{
                width: 48px;
                height: 48px;
                position: absolute;
                top: 50%;
                left: 50%;
                margin-left: -24px;
                margin-top: -64px;
                display: none;
            }
            .video-thumb{
                width: 100%;
                height: 152px;
                border-radius: 6px 6px 0 0;
                margin-bottom: 8px;
            }
            .video-item-title{
	            max-width: 90%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                padding: 0 8px;
                margin-bottom:8px;
            }
            .video-item-category{
                padding: 0 8px;
                margin-bottom: 8px;
	            display: flex;
	            align-items: center;
	            span:first-child{
		            max-width: 120px;
		            display: inline-block;
	            }
	            .space{
		            margin: 0 5px;
	            }
            }
            .video-item-tag{
                padding: 0 8px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                p{
                    white-space: nowrap;
                    .category-tag{
	                    max-width: 50%;
                        color: #ffffff;
                        padding: 2px 8px 2px;
                        border-radius: 4px;
                        white-space: nowrap;
                        display: inline-block;
	                    font-size: 12px;
	                    overflow: hidden;
	                    text-overflow:ellipsis;
                    }
                }
	            p:last-child{
		            text-align: right;
	            }
                .collect{
	                display: flex;
	                align-items: center;
	                justify-content: flex-end;
                    img{
                        width: 14px;
                        height: 14px;
                        display: inline-block;
                        margin-right: 5px;
                        position: relative;
                        top: 1px;
                    }
                }
            }
        }
        .video-items:nth-child(5n){ margin-right: 0;}
        .video-items:hover{
            transform: translateY(-2px);
            box-shadow: 0 12px 20px 0 rgba(95,101,105,.15);
            .mask-layer{
                display: block;
            }
        }
    }
    .lg-collect-video{
        .video-items{
            width: 232px;
            margin-right: 14px;
            margin-bottom: 20px;
            .collect-category_tag{
                color: #ffffff;
	            font-size: 12px;
                padding: 2px 8px 2px;
                border-radius: 4px;
                white-space: nowrap;
                max-width: 70px;
                display: inline-block;
                overflow: hidden;
                text-overflow:ellipsis;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/video/video.vue